export default __webpack_public_path__ + "static/black-desserto-sand-3652f94a3bc6b32d724adf2519e5fb42.jpg";